export type ISetupModal = (e: JQuery.BsModalEvent<HTMLElement>) => void;
export default function setupModal(e: JQuery.BsModalEvent<HTMLElement>) {
  const $modal = $(e.target) as IjQueryElm;
  const $button = $(e.relatedTarget);
  const $modalDialog = $modal.find('.modal-dialog');

  $modalDialog.focus();
  window.DexeroCoreApp.trapTabKeyInModal($modal);

  if (Boolean($button.length)) {
    window.DexeroCoreApp.lastModalTrigger = $button;
  }
}
